interface ArchiveConfirmModalProps {
  archiveTarget: {
    id: string;
    name: string;
  } | null;
  isArchiving: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
}

export function ArchiveConfirmModal({
  archiveTarget,
  isArchiving,
  onClose,
  onConfirm,
}: ArchiveConfirmModalProps) {
  if (!archiveTarget) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900/50 p-4 backdrop-blur-sm">
      <div className="w-full max-w-md overflow-hidden rounded-xl bg-white p-6 shadow-xl">
        <div className="flex items-center gap-3 text-slate-700">
          <h3 className="text-base font-semibold text-gray-900">
            Archive Authority
          </h3>
        </div>

        <p className="mt-3 text-sm text-gray-600">
          Are you sure you want to archive <span className="font-semibold text-gray-900">"{archiveTarget.name}"</span>?
          <span className="block mt-2 text-xs text-amber-700 bg-gray-100 border border-gray-200 rounded-lg p-2.5">
            Note: All services under this authority will also be archived and hidden from client panel and new service creation.
          </span>
        </p>

        <div className="mt-6 flex justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            className="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={isArchiving}
            className="rounded-lg bg-amber-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-amber-700 disabled:opacity-50"
          >
            {isArchiving ? 'Archiving...' : 'Archive'}
          </button>
        </div>
      </div>
    </div>
  );
}
